import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { isletmeGirisYap, garsonGirisYap } from '../services/api';

// Landing sayfasındaki "Kurum Girişi" için — belirli bir işletmenin /:slug/ayarlar sayfasını bilmeye
// gerek kalmadan, İşletme Kodu (slug) + Kullanıcı Adı + Şifre ile doğrudan giriş.
export default function GlobalGiris() {
  const navigate = useNavigate();
  const [isletmeKodu, setIsletmeKodu] = useState('');
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const girisYap = (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    const kod = isletmeKodu.trim().toLowerCase();
    isletmeGirisYap(kullaniciAdi, sifre, kod)
      .then((res) => {
        localStorage.setItem('isletmeId', res.data.id);
        localStorage.setItem('isletmeAd', res.data.ad);
        localStorage.setItem('isletmeSlug', res.data.slug);
        localStorage.setItem('isletmeRol', 'MUDUR');
        navigate(`/${res.data.slug}/ayarlar/panel`);
      })
      .catch(() => {
        garsonGirisYap(kullaniciAdi, sifre, kod)
          .then((res) => {
            localStorage.setItem('isletmeId', res.data.id);
            localStorage.setItem('isletmeAd', res.data.ad);
            localStorage.setItem('isletmeSlug', res.data.slug);
            localStorage.setItem('isletmeRol', 'GARSON');
            navigate(`/${res.data.slug}/ayarlar/panel`);
          })
          .catch((err) => setHata(err.response?.data?.hata || 'Giriş yapılamadı. İşletme kodu, kullanıcı adı veya şifreyi kontrol edin.'));
      })
      .finally(() => setYukleniyor(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
      <form onSubmit={girisYap} className="kart" style={{ width: 360 }}>
        <h2 style={{ marginTop: 0, color: '#1e2a3a' }}>Kurum Girişi</h2>
        {hata && <div className="hata-kutu">{hata}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>İşletme Kodu</label>
          <input value={isletmeKodu} onChange={(e) => setIsletmeKodu(e.target.value)} placeholder="Örn: oguzcafe" required />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
          <input value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
          <input type="password" value={sifre} onChange={(e) => setSifre(e.target.value)} required />
        </div>
        <button type="submit" disabled={yukleniyor} className="btn btn-vurgu" style={{ width: '100%' }}>
          {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}>
          Hesabınız yok mu? <Link to={`${process.env.PUBLIC_URL}/yeni-hesap`} style={{ color: '#e8600c', fontWeight: 700 }}>7 gün ücretsiz deneyin</Link>
        </div>
      </form>
    </div>
  );
}
